"use strict";

exports.__esModule = true;
exports.default = exports.caretSet = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = require("react-dom");

var _Input = _interopRequireDefault(require("./Input"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var caretSet = function caretSet(node, start, end) {
  if (end === void 0) {
    end = start;
  }

  try {
    node.setSelectionRange(start, end);
  } catch (e) {
    /* not focused or not visible */
  }
};

exports.caretSet = caretSet;

var ComboboxInput =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ComboboxInput, _React$Component);

  function ComboboxInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          placeholder = _this$props.placeholder,
          value = _this$props.value,
          onChange = _this$props.onChange;
      var stringValue = e.target.value;
      var hasPlaceholder = !!placeholder; // IE fires input events when setting/unsetting placeholders.
      // issue #112

      if (hasPlaceholder && !stringValue && stringValue === (value || '')) return;
      _this._last = stringValue;
      onChange(e, stringValue);
    };

    return _this;
  }

  var _proto = ComboboxInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var input = (0, _reactDom.findDOMNode)(this);
    var val = this.props.value;

    if (this.isSuggesting()) {
      var start = val.toLowerCase().indexOf(this._last.toLowerCase()) + this._last.length;

      var end = val.length - start;

      if (start >= 0 && end !== 0) {
        caretSet(input, start, start + end);
      }
    }
  };

  _proto.accept = function accept(clearSelection) {
    if (clearSelection === void 0) {
      clearSelection = false;
    }

    this._last = null;

    if (clearSelection) {
      var node = (0, _reactDom.findDOMNode)(this);
      caretSet(node, node.value.length);
    }
  };

  _proto.focus = function focus() {
    (0, _reactDom.findDOMNode)(this).focus();
  };

  _proto.isSuggesting = function isSuggesting() {
    var _this$props2 = this.props,
        value = _this$props2.value,
        suggest = _this$props2.suggest;
    if (!suggest) return false;
    return this._last != null && value.toLowerCase().indexOf(this._last.toLowerCase()) !== -1;
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        onKeyDown = _this$props3.onKeyDown,
        props = _objectWithoutProperties(_this$props3, ["onKeyDown"]);

    delete props.suggest;
    return _react.default.createElement(_Input.default, _extends({}, props, {
      className: "rw-widget-input",
      onKeyDown: onKeyDown,
      onChange: this.handleChange
    }));
  };

  return ComboboxInput;
}(_react.default.Component);

ComboboxInput.defaultProps = {
  value: ''
};
ComboboxInput.propTypes = {
  value: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  suggest: _propTypes.default.bool,
  onChange: _propTypes.default.func.isRequired,
  onKeyDown: _propTypes.default.func
};
var _default = ComboboxInput;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/react-widgets/lib/ComboboxInput.js
// module id = 1961
// module chunks = 0